import type { Action, PayloadAction } from "@reduxjs/toolkit";
import * as actions from "./actions";
import type { IActiveCategory } from "./models";

const initialState: IActiveCategory = {
  category: document.getElementById("site-search-box")?.dataset.currentCategory ?? undefined,
};

export default function activeCategoryReducer(
  state: IActiveCategory,
  action: Action,
): IActiveCategory {
  if (typeof state === "undefined") {
    return initialState;
  }
  switch (action.type) {
    case actions.UPDATE: {
      const data = (action as PayloadAction<IActiveCategory>).payload;
      return { ...data };
    }
    case actions.CLEAR: {
      return {
        ...state,
        category: undefined,
      };
    }
    default:
      return state;
  }
}
